import type { ApiResponse } from '@/types/api-response.types'
import type { LiveStream, LiveStreamDetail } from '@/types/live-stream.types'
import api from '../axios'

export const liveStreamService = {
  async getLiveStreams(): Promise<LiveStream[]> {
    const response: ApiResponse<LiveStream[]> = await api.get('/v1/live-stream')
    return response.body
  },

  async getLiveStreamDetail(idx: number): Promise<LiveStreamDetail> {
    const response: ApiResponse<LiveStreamDetail> = await api.get(`/v1/live-stream/${idx}`)
    return response.body
  },

  async toggleNotification(idx: number): Promise<boolean> {
    const response: ApiResponse<boolean> = await api.post(`/v1/live-stream/${idx}/notification`)
    return response.body
  },
}
